export default __webpack_public_path__ + "static/media/thumb.fb316c6a.webp";